"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colors = void 0;
const dark = {
    50: '#11111193',
    100: '#111111a2',
    200: '#111111B3',
    400: '#111111CC',
    500: '#111111d8',
    600: '#111111eb',
    700: '#111111',
};
const neutral = {
    50: '#fafafa',
    100: '#f2f2f2',
    200: '#ededed',
    300: '#dedede',
    400: '#cccccc',
    500: '#666666',
    600: '#434343',
    700: '#343434',
    800: '#232323',
    900: '#090909',
};
const light = {
    500: '#11111140',
    600: '#11111168',
    900: '#111111',
};
const primaryGradient = {
    100: '#00a4dc',
    200: '#0090ce',
    300: '#007dbf',
    800: '#005ba1',
    900: '#004480',
};
const primary = {
    50: '#e0ecf9',
    100: '#b3d1f0',
    200: '#80b2e6',
    300: '#4d93db',
    400: '#267bd4',
    500: '#0164cc',
    600: '#005cc7',
    700: '#0052c0',
    800: '#0048b9',
    900: '#0036ad',
};
const white = '#ffffff';
exports.colors = {
    light,
    neutral,
    dark,
    primary,
    link: '#0064cc',
    payback: '#0046aa',
    anchor: '#2b47e6',
    white,
    black: '#000000',
    primaryGradient,
    error: '#dc3545',
    success: '#28a745',
    text: dark[700],
    darkGrey: neutral[900],
    lightGrey: neutral[300],
    shadowLight: '#11111180',
    loadingSpinnerColor: dark[100],
    transparent: 'transparent',
    loadingOverlay: {
        backgroundColor: '#1111116B',
        spinner: {
            color: '#111111',
            spinningColor: 'transparent',
        },
    },
    appBackground: {
        primary: white,
        secondary: neutral[50],
        tertiary: neutral[100],
    },
};
